import { render } from "./ViewRecensementPage.vue?vue&type=template&id=094ea674&ts=true"
import script from "./ViewRecensementPage.vue?vue&type=script&lang=ts"
export * from "./ViewRecensementPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__